import axios from 'axios';
import { useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { useGoogleLogin } from '@react-oauth/google';

import Button from '@mui/material/Button';

// import { getLoginGmail } from 'store/user-actions';
import classes from './LoginUDC.module.css';

const LoginUDC = () => {
  //   const dispatch = useDispatch();
  const [user, setUser] = useState([]);

  const login = useGoogleLogin({
    onSuccess: codeResponse => {
      setUser(codeResponse);
      console.log(codeResponse);
      //   Cookies.set('gjw', codeResponse.access_token);
      //   dispatch(getLoginGmail(codeResponse.access_token));
    },
    onError: error => console.log('Login Failed:', error)
  });

  useEffect(() => {
    if (user) {
      axios
        .get('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: {
            Authorization: `Bearer ${user.access_token}`
          }
        })
        .then(response => {
          Cookies.set('gjw', response.tokenId);
          window.localStorage.setItem(
            'zhinzwod',
            JSON.stringify(response.tokenObj)
          );
          //   this.props.then(responseLoginGoogle => {
          //     if (responseLoginGoogle.value.data.value) {
          //       if (this.props.renewSession) {
          //         this.props.renewSessionHandler();
          //       } else {
          //         if (this.props.prevUrl) {
          //           window.location.href = `/${this.props.prevUrl}`;
          //         } else {
          //           window.location.href = '/campus/udcLessons';
          //         }
          //       }
          //     }
          //   });
          console.log('res.data', response.data);
        })
        .catch(err => console.log(err));
    }
  }, [user]);

  return (
    <div className={classes.loginContainer}>
      <div className={classes.infoContainer}>
        <p className={classes.title}>Bienvenid@ al Campus UDC</p>
        <div className={classes.inputContainer}>
          <figure className={classes.avatar}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/LogoUDC_EduStore.png"
              alt=""
            />
          </figure>
          <p className={classes.subtitle}>INICIA SESIÓN</p>
          <p className={classes.description}>Con tu cuenta UDC</p>
          <Button
            type="button"
            className={classes.loginBtn}
            onClick={() => login()}
          >
            Acceder con Google
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoginUDC;
